import { IconProps } from "../../utils/global-types/global-types";

const EmojiIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 2.333a6.666 6.666 0 1 1 0 13.333A6.666 6.666 0 0 1 9 2.333m1.867 7.905A2.66 2.66 0 0 1 9 11a2.66 2.66 0 0 1-1.867-.762.668.668 0 1 0-.933.952A4 4 0 0 0 9 12.333a4 4 0 0 0 2.8-1.143.667.667 0 0 0-.933-.952m-4.2-3.905a1 1 0 1 0 0 2 1 1 0 0 0 0-2m4.667 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export default EmojiIcon;
